import React, { useEffect, useRef, useState } from 'react';
import { Button, Form, Image } from 'react-bootstrap';
import { doc, updateDoc } from "firebase/firestore";
import ClipLoader from "react-spinners/ClipLoader";
import { ref, getDownloadURL, uploadBytes } from "firebase/storage";
import OutletHead from '../../../../components/common/outlet-head';
import { db, storage } from '../../../../firebase';
import { useAuth } from '../../../../context/AuthContext';
import ImageIcon from '../../../../assets/images/placeholder/image-icon.webp';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Skeleton from 'react-loading-skeleton';
import StatesCities from '../../../../assets/json/states-and-districts.json';

function CompanySettings() {

  const { businessProfile } = useAuth();
  let navigate = useNavigate();
  let logoRef = useRef();

  const [isLoading, setIsLoading] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);
  const [companyData, setCompanyData] = useState({
    companyLogo: null,
    businessName: '',
    address: '',
    pincode: '',
    city: '',
    state: '',
    cin: '',
    pan: '',
    gst: '',
    rera: '',
    phoneNumber: '',
    alternateNumber: '',
    email: '',
    website: '',
    signature: null,
    paymentDetails: null,
    subscription: false
  });
  const [cityList, setCityList] = useState(null);
  const [inputError, setInputError] = useState();

  function getStateCities(state) {
    const filteredCitiesByState = StatesCities && StatesCities.find(val => val.state === state).districts;

    if (filteredCitiesByState) {
      setCityList(filteredCitiesByState);
    }
  }

  useEffect(() => {
    if (businessProfile) {
      setCompanyData(businessProfile);
      getStateCities(businessProfile.state);
    }

    setIsLoading(false);
  }, [businessProfile]);

  async function handleCompanyData(id, data) {
    const tempData = { ...data, updatedOn: new Date() };
    try {
      await updateDoc(doc(db, "Businesses", id), tempData);
      setIsUpdating(false);
      toast.success('Successfully Updated');
    } catch (error) {
      console.log('Updating Settings [Error] : ', error);
      setIsUpdating(false);
    }
  }

  function handleCompanyDataWithLogo(id, companyLogoObj) {
    const storageRef = ref(storage, `/Company-Logo/${id}`);
    var tempDoc = { ...companyData, companyLogo: null };
    uploadBytes(storageRef, companyLogoObj).then((snapshot) => {
      getDownloadURL(snapshot.ref).then((url) => {
        tempDoc = { ...tempDoc, companyLogo: url };
        handleCompanyData(id, tempDoc);
      });
    });
  }

  function validateData() {
    const { businessName, phoneNumber, state } = companyData;
    if (!businessName) {
      setInputError({ ...inputError, businessName: 'This field is required.' });
    } else if (!state) {
      setInputError({ ...inputError, state: 'This field is required.' });
    } else if (!phoneNumber) {
      setInputError({ ...inputError, phoneNumber: 'This field is required.' });
    } else {
      if (typeof companyData.companyLogo === 'string' || companyData.companyLogo === null) {
        setIsUpdating(true);
        handleCompanyData(companyData.id, companyData);
      } else {
        setIsUpdating(true);
        handleCompanyDataWithLogo(companyData.id, companyData.companyLogo);
      }
    }
  }

  return (
    <section className='section'>
      <OutletHead
        left={
          <div className='custom-header'>
            <h5 className='mb-0 fw-600'>Business Settings</h5>
            <p className='mb-0 text-muted'>
              <small>Edit your business settings and information</small>
            </p>
          </div>
        }
        right={
          <div className='d-flex align-items-center'>
            <Button
              variant="light"
              type="submit"
              className='border py-2 btn-width me-3'
              onClick={() => navigate('/admin/dashboard')}
            >
              <span className='px-4'>Cancel</span>
            </Button>
            <Button
              disabled={companyData && companyData === businessProfile && businessProfile}
              variant="primary"
              type="submit"
              className='py-2 btn-width'
              onClick={validateData}
            >
              {
                isUpdating ?
                  <div className='d-flex align-items-center justify-content-center'>
                    <span className='me-2'>Saving</span>
                    <ClipLoader color='white' size={16} />
                  </div>
                  :
                  <span>Save Changes</span>
              }
            </Button>
          </div>
        }
      />
      <div className='form-wrapper border-top' >
        {
          isLoading ?
            <div className='row px-3'>
              <div className='col-2 mt-3'>
                <Skeleton height={180} />
              </div>
              <div className='col-6'>
                <div className='row'>
                  <div className='col-12 mt-3'>
                    <Skeleton height={42} />
                  </div>
                  <div className='col-12 mt-3'>
                    <Skeleton height={64} />
                  </div>
                  <div className='col-6 mt-3'>
                    <Skeleton height={42} />
                  </div>
                  <div className='col-6 mt-3'>
                    <Skeleton height={42} />
                  </div>
                  <div className='col-12 mt-3'>
                    <Skeleton height={42} />
                  </div>
                  <div className='col-6 mt-3'>
                    <Skeleton height={42} />
                  </div>
                  <div className='col-6 mt-3'>
                    <Skeleton height={42} />
                  </div>
                  <div className='col-6 mt-3'>
                    <Skeleton height={42} />
                  </div>
                  <div className='col-6 mt-3'>
                    <Skeleton height={42} />
                  </div>
                </div>
              </div>
              <div className='col-4'>
                <div className='row'>
                  <div className='col-12 mt-3'>
                    <Skeleton height={42} />
                  </div>
                  <div className='col-12 mt-3'>
                    <Skeleton height={42} />
                  </div>
                  <div className='col-12 mt-3'>
                    <Skeleton height={42} />
                  </div>
                  <div className='col-12 mt-3'>
                    <Skeleton height={42} />
                  </div>
                </div>
              </div>
            </div>
            :
            <div className='p-3'>
              <div className='row'>
                <div className='col-2 pe-md-0'>
                  <div className='border overflow-hidden rounded p-3 d-flex align-items-center justify-content-center'>
                    <div>
                      <Form.Group hidden controlId="companyLogo" className="mb-3">
                        <Form.Control
                          ref={logoRef}
                          type="file"
                          accept="image/*"
                          onChange={(event) => {
                            setCompanyData({
                              ...companyData,
                              companyLogo: event.target.files[0]
                            });
                          }}
                        />
                      </Form.Group>
                      <Button
                        variant='link'
                        className='p-0 border border-light rounded mb-3'
                        onClick={() => logoRef.current.click()}
                      >
                        {
                          companyData && typeof companyData.companyLogo === 'string' ?
                            <Image src={companyData && companyData.companyLogo ? companyData.companyLogo : ImageIcon} alt='company-logo' width={'100%'} height={'100%'} rounded />
                            :
                            <Image src={companyData && companyData.companyLogo ? URL.createObjectURL(companyData.companyLogo) : ImageIcon} alt='company-logo' width={'100%'} height={'100%'} rounded />
                        }
                      </Button>
                      <Button
                        variant='outline-primary'
                        size='sm'
                        className='border py-1 w-100 text-decoration-none'
                        onClick={() => logoRef.current.click()}
                      >
                        {companyData && typeof companyData.companyLogo ? 'Change Logo' : 'Upload Logo'}
                      </Button>
                    </div>
                  </div>
                </div>
                <div className='col-md-10'>
                  <div className='border overflow-hidden rounded p-3'>
                    <div className='row'>
                      <div className='col-md-8'>
                        <div className='row'>
                          <div className='col-12'>
                            <Form.Group className="w-100" controlId="businessName">
                              <Form.Label>Business Name *</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter business name"
                                onChange={(e) => {
                                  setCompanyData({
                                    ...companyData,
                                    businessName: e.target.value,
                                  });
                                  setInputError({ ...inputError, businessName: '' })
                                }}
                                className={inputError && inputError.businessName ? 'border-danger' : null}
                                value={companyData && companyData.businessName}
                                isInvalid={inputError && inputError.businessName}
                              />
                              <Form.Control.Feedback type="invalid">{inputError && inputError.businessName}</Form.Control.Feedback>
                            </Form.Group>
                          </div>
                          <div className='col-md-12 col-12'>
                            <Form.Group className='mt-3' controlId="address">
                              <Form.Label>Billing Address</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder='Enter address'
                                onChange={(e) => {
                                  const { id, value } = e.target;
                                  setInputError({ ...inputError, [id]: '' });
                                  setCompanyData((prevData) => {
                                    return { ...prevData, [id]: value };
                                  });
                                }}
                                className='text-capitalize'
                                value={companyData && companyData.address}
                              />
                            </Form.Group>
                          </div>
                          <div className='col-md-6 col-12'>
                            <Form.Group className='mt-3' controlId="state">
                              <Form.Label>State *</Form.Label>
                              <Form.Select
                                className={inputError && inputError.state ? 'border-danger bg-white' : 'bg-white'}
                                onChange={(e) => {
                                  const { id, value } = e.target;
                                  setInputError({ ...inputError, [id]: '' });
                                  setCompanyData((prevData) => {
                                    return { ...prevData, [id]: value, city: '' };
                                  });
                                  getStateCities(value);
                                }}
                                value={companyData && companyData.state}
                                isInvalid={inputError && inputError.state}
                              >
                                <option>Select</option>
                                {
                                  StatesCities && StatesCities.map((item, index) => {
                                    return (
                                      <option key={index} value={item.state}>{item.state}</option>
                                    )
                                  })
                                }
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">{inputError && inputError.state}</Form.Control.Feedback>
                            </Form.Group>
                          </div>
                          <div className='col-md-6 col-12'>
                            <Form.Group className='mt-3' controlId="pincode">
                              <Form.Label>Pincode</Form.Label>
                              <Form.Control
                                maxLength={6}
                                placeholder='Enter pincode'
                                onChange={(e) => {
                                  const { id, value } = e.target;
                                  const regEx = /^[0-9\b]+$/;
                                  if (value === '' || regEx.test(value)) {
                                    setInputError({ ...inputError, [id]: '' });
                                    setCompanyData((prevData) => {
                                      return { ...prevData, [id]: value };
                                    });
                                  }
                                }}
                                value={companyData && companyData.pincode}
                              />
                            </Form.Group>
                          </div>
                          <div className='col-md-12 col-12'>
                            <Form.Group className='mt-3' controlId="city">
                              <Form.Label>City *</Form.Label>
                              <Form.Select
                                placeholder='Enter city'
                                onChange={(e) => {
                                  const { id, value } = e.target;
                                  setInputError({ ...inputError, [id]: '' });
                                  setCompanyData((prevData) => {
                                    return { ...prevData, [id]: value };
                                  });
                                }}
                                value={companyData && companyData.city}
                                isInvalid={inputError && inputError.city}
                              >
                                <option>Select</option>
                                {
                                  cityList && cityList.map((item, index) => {
                                    return (
                                      <option key={index} value={item}>{item}</option>
                                    )
                                  })
                                }
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">{inputError && inputError.city}</Form.Control.Feedback>
                            </Form.Group>
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-md-6 col-12'>
                            <Form.Group className='mt-3' controlId="phoneNumber">
                              <Form.Label>Phone Number *</Form.Label>
                              <Form.Control
                                maxLength={10}
                                placeholder='Enter 10 digit phone number'
                                className={inputError && inputError.phoneNumber ? 'border-danger' : ''}
                                onChange={(e) => {
                                  const { id, value } = e.target;
                                  const regEx = /^[0-9\b]+$/;
                                  if (value === '' || regEx.test(value)) {
                                    setInputError({ ...inputError, [id]: '' });
                                    setCompanyData((prevData) => {
                                      return { ...prevData, [id]: value };
                                    });
                                  }
                                }}
                                value={companyData && companyData.phoneNumber}
                                isInvalid={inputError && inputError.phoneNumber}
                              />
                              <Form.Control.Feedback type="invalid">{inputError && inputError.phoneNumber}</Form.Control.Feedback>
                            </Form.Group>
                          </div>
                          <div className='col-md-6 col-12'>
                            <Form.Group className='mt-3' controlId="alternateNumber">
                              <Form.Label>Alternate Number</Form.Label>
                              <Form.Control
                                maxLength={10}
                                placeholder='Enter 10 digit alternate number'
                                onChange={(e) => {
                                  const { id, value } = e.target;
                                  const regEx = /^[0-9\b]+$/;
                                  if (value === '' || regEx.test(value)) {
                                    setInputError({ ...inputError, [id]: '' });
                                    setCompanyData((prevData) => {
                                      return { ...prevData, [id]: value };
                                    });
                                  }
                                }}
                                value={companyData && companyData.alternateNumber}
                              />
                            </Form.Group>
                          </div>
                          <div className='col-md-6 col-12'>
                            <Form.Group className='mt-3' controlId="email">
                              <Form.Label>Email</Form.Label>
                              <Form.Control
                                type='email'
                                placeholder='user@example.com'
                                onChange={(e) => {
                                  const { id, value } = e.target;
                                  setInputError({ ...inputError, [id]: '' });
                                  setCompanyData((prevData) => {
                                    return { ...prevData, [id]: value };
                                  });
                                }}
                                value={companyData && companyData.email}
                              />
                            </Form.Group>
                          </div>
                          <div className='col-md-6 col-12'>
                            <Form.Group className='mt-3' controlId="website">
                              <Form.Label>Website</Form.Label>
                              <Form.Control
                                placeholder='https://www.example.com'
                                onChange={(e) => {
                                  const { id, value } = e.target;
                                  setInputError({ ...inputError, [id]: '' });
                                  setCompanyData((prevData) => {
                                    return { ...prevData, [id]: value };
                                  });
                                }}
                                value={companyData && companyData.website}
                              />
                            </Form.Group>
                          </div>
                        </div>
                      </div>
                      <div className='col-4 border-start'>
                        <div className='row'>
                          <div className='col-12'>
                            <Form.Group controlId="cin">
                              <Form.Label>CIN</Form.Label>
                              <Form.Control
                                maxLength={21}
                                placeholder='Enter CIN'
                                onChange={(e) => {
                                  const { id, value } = e.target;
                                  setInputError({ ...inputError, [id]: '' });
                                  setCompanyData((prevData) => {
                                    return { ...prevData, [id]: value.toUpperCase() };
                                  });
                                }}
                                value={companyData && companyData.cin}
                              />
                            </Form.Group>
                          </div>
                          <div className='col-12'>
                            <Form.Group className='mt-3' controlId="pan">
                              <Form.Label>PAN</Form.Label>
                              <Form.Control
                                maxLength={10}
                                placeholder='Enter PAN'
                                onChange={(e) => {
                                  const { id, value } = e.target;
                                  setInputError({ ...inputError, [id]: '' });
                                  setCompanyData((prevData) => {
                                    return { ...prevData, [id]: value.toUpperCase() };
                                  });
                                }}
                                value={companyData && companyData.pan}
                              />
                            </Form.Group>
                          </div>
                          <div className='col-12'>
                            <Form.Group className='mt-3' controlId="gst">
                              <Form.Label>GST</Form.Label>
                              <Form.Control
                                maxLength={15}
                                placeholder='Enter GST'
                                onChange={(e) => {
                                  const { id, value } = e.target;
                                  setInputError({ ...inputError, [id]: '' });
                                  setCompanyData((prevData) => {
                                    return { ...prevData, [id]: value.toUpperCase() };
                                  });
                                }}
                                value={companyData && companyData.gst}
                              />
                            </Form.Group>
                          </div>
                          <div className='col-12'>
                            <Form.Group className='mt-3' controlId="rera">
                              <Form.Label>RERA (Reg. No.)</Form.Label>
                              <Form.Control
                                placeholder='Enter RERA reg. no.'
                                onChange={(e) => {
                                  const { id, value } = e.target;
                                  setInputError({ ...inputError, [id]: '' });
                                  setCompanyData((prevData) => {
                                    return { ...prevData, [id]: value.toUpperCase() };
                                  });
                                }}
                                value={companyData && companyData.rera}
                              />
                            </Form.Group>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        }
      </div>
    </section>
  );
}

export default CompanySettings;
